import { alertReducerObject } from '@calendly/alert'
import { onetrustReducerObject } from '@calendly/onetrust/redux'

import { reducer as eventInviteesExport } from 'components/export/event_invitees'
import { reducer as adaChatReducer } from 'components/external/ada_chat_bot'
import { accountSettingsReducer } from 'features/account_settings'
import { reducer as activityLogReducer } from 'features/activity_log'
import { addUsersToGroup } from 'features/add_users_to_group'
import { reducer as adminSettings } from 'features/admin'
import { reducer as billingReducer } from 'features/billing'
import { bookModal } from 'features/book_modal'
import { contacts } from 'features/contacts'
import { reducer as contextualHelpReducer } from 'features/contextual_help'
import { crm } from 'features/crm'
import { reducer as eventTypeExport } from 'features/event_type_export'
import { reducer as extensionPromotionReducer } from 'features/extension_promotion'
import { reducer as hostReschedule } from 'features/host_reschedule'
import { organizationOutlookReducer as organizationOutlook } from 'features/integrations'
import { invitationsExport } from 'features/invitations_export'
import { inviteFlowReducer } from 'features/invite_flow'
import { reducer as leftNavigationReducer } from 'features/left_navigation'
import { managedEventTypesReducer } from 'features/managed_event_types'
import { reducer as meetingIntelligenceReducer } from 'features/meeting_intelligence'
import { reducer as meetingsPageReducer } from 'features/meetings'
import { membershipsPickerReducer } from 'features/memberships_picker'
import { reducer as objectLevelPermissions } from 'features/object_level_permissions'
import { offerTimeSlotsModalReducer } from 'features/offer_time_slots_modal'
import { reducer as oneOffModalReducer } from 'features/one_off_modal/slice'
import { oneOffShareReducer } from 'features/one_off_share_modal'
import { bookingVerificationReducer, organizationSettingsReducer } from 'features/organization_settings'
import { organizationStatistics } from 'features/organization_statistics'
import { reducer as personalSettings } from 'features/personal'
import { phoneNumbersReducer } from 'features/phone_numbers'
import { reducer as reportingReducer } from 'features/reporting'
import { routingFormsEditPageReducerObject, routingFormsIndexPageReducerObject } from 'features/routing'
import { schedulingReducer } from 'features/scheduling'
import { reducer as seatRequestsReducer } from 'features/seat_requests'
import { reducer as sendFromCalendly } from 'features/send_from_calendly'
import { reducer as sidebarPlaceholderReducer } from 'features/sidebar_placeholder'
import { teamFormReducer } from 'features/team_form'
import { reducer as upgradeBannerReducer } from 'features/upgrade_banner'
import { userGroupsReducer } from 'features/user_groups'
import { usersExport } from 'features/users_export'
import { usersPage } from 'features/users_page'
import { reducerRegistry } from 'reducer-registry'

import bulkToolbar from './bulk_toolbar'
import passthrough from './core/passthrough'
import filters from './filters'
import gdpr from './gdpr'
import homeBar from './home_bar'
import integrations from './integrations'
import { meetingsFilterModal } from './meetings_filter_modal'
import quickCreate from './quick_create'
import scheduledEvents from './scheduled_events'
import workflows from './workflows'

const reducers = {
  account_settings: accountSettingsReducer,
  activityLog: activityLogReducer,
  ada_chat: adaChatReducer,
  addUsersToGroup,
  adminSettings,
  ...alertReducerObject,
  billing: billingReducer,
  bookModal,
  bookingVerification: bookingVerificationReducer,
  bulkToolbar,
  contacts,
  contextualHelp: contextualHelpReducer,
  crm,
  eventInviteesExport,
  eventTypeExport,
  experiments: passthrough,
  extensionPromotion: extensionPromotionReducer,
  filters,
  gdpr,
  home: passthrough,
  home_bar: homeBar,
  hostReschedule,
  integrations,
  invitationsExport,
  inviteFlow: inviteFlowReducer,
  leftNavigation: leftNavigationReducer,
  managedEventTypes: managedEventTypesReducer,
  meetingIntelligence: meetingIntelligenceReducer,
  meetingsFilterModal,
  meetingsPage: meetingsPageReducer,
  membershipsPicker: membershipsPickerReducer,
  objectLevelPermissions,
  offerTimeSlotsModal: offerTimeSlotsModalReducer,
  oneOffModal: oneOffModalReducer,
  oneOffShare: oneOffShareReducer,
  ...onetrustReducerObject,
  organizationOutlook,
  organizationSettings: organizationSettingsReducer,
  organizationStatistics,
  personalSettings,
  phoneNumbers: phoneNumbersReducer,
  quick_create: quickCreate,
  reporting: reportingReducer,
  ...routingFormsIndexPageReducerObject,
  ...routingFormsEditPageReducerObject,
  scheduled_events: scheduledEvents,
  scheduling: schedulingReducer,
  seatRequests: seatRequestsReducer,
  segment: passthrough,
  sendFromCalendly,
  sidebar_placeholder: sidebarPlaceholderReducer,
  teamForm: teamFormReducer,
  upgradeBanner: upgradeBannerReducer,
  userGroups: userGroupsReducer,
  usersExport,
  usersPage,
  workflows,
}

Object.entries(reducers).forEach(([key, value]) => reducerRegistry.add(key, value))
